import React from 'react';
import { styled } from '@mui/material';

import { useViewport } from 'contexts/viewport';
import { Box, Icon, Stack, Text } from 'shell/components';
import { TeamAnalyticsWithStatus } from 'components/molecules/Analytics';
import LeaderBoard from './LeaderBoard';
import { useUser2 } from 'contexts/user2';
import { getAverage } from 'utils/helper';

const GroupProgressInformation = ({ className, ...rest }) => {
    const { distribution, groups } = useUser2();
    const { device } = useViewport();

    const classAverage = Number(getAverage(distribution, groups)).toFixed(1);

    return (
        <RootStack className={className} alignItems={'center'} device={device} justifyContent={'center'} {...rest}>
            <CustomBox device={device}>
                <TeamAnalyticsStack alignItems={'center'} spacing={2}>
                    <TeamAnalyticsWithStatus classAverage={classAverage} />
                </TeamAnalyticsStack>
                <LeadeBoardStack sx={{ gridColumn: '2 / 5' }} alignItems={'center'} spacing={2}>
                    <LeaderBoard groups={groups} distribution={distribution} />
                </LeadeBoardStack>
            </CustomBox>
        </RootStack>
    );
};

const RootStack = styled(Stack)(({ device, theme }) => {
    return {
        padding: theme.spacing(3),
        background: theme.palette.ensightful.primary[50],
        ...(device === 'mobile' && {
            width: '100%',
        }),
    };
});

const CustomBox = styled(Box)(({ device, theme }) => {
    return {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gridGap: theme.spacing(4),
        width: '100%',
        height: '100%',
        ...(device === 'mobile' && {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(4),
        }),
    };
});

const TeamAnalyticsStack = styled(Stack)(({ theme }) => {
    return {
        padding: theme.spacing(3, 0),
        borderRadius: theme.spacing(2),
        background: theme.palette.ensightful.shades[0],
    };
});

const LeadeBoardStack = styled(Stack)(({ theme }) => {
    return {
        padding: theme.spacing(3, 5),
        borderRadius: theme.spacing(2),
        background: theme.palette.ensightful.shades[0],
    };
});

export default GroupProgressInformation;
